export default "__VITE_ASSET__BVQUZehz__"